import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-parameters',
  templateUrl: './turns-parameters.component.html',
  styleUrls: ['./turns-parameters.component.scss']
})
export class TurnsParametersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
